import React from "react";

const Media = () => {
  const videos = [
    {
      id: "t6_e5NOEPqU",
      title: "Agnus Dei – Georges Bizet",
      description: "",
    },
    {
      id: "FXOUfnDHQ1o",
      title: "Non t’amo più – Francesco Paolo Tosti",
      description: "",
    },
    {
      id: "i2m7kS8fDp0",
      title: "Home Sweet Home",
      description: "",
    },
    {
      id: "DlR-Q-cohzQ",
      title: "Messiah (Rehearsal)",
      description: "",
    },
    {
      id: "7-b4Pyapo6U",
      title: "The Call – Ralph Vaughan Williams",
      description: "",
    },
  ];

  const photos = ["/images/singing1.jpg", "/images/singing2.jpg"];

  return (
    <div className="bg-alice text-space min-h-screen">
      <section className="max-w-5xl mx-auto px-4 py-12">
        <h1 className="text-4xl md:text-5xl font-playfair font-bold text-center mb-4 text-space">
          Media Gallery
        </h1>

        {/* YouTube Channel Link */}
        <div className="text-center mb-10">
          <a
            href="https://www.youtube.com/channel/UCBCdXKkGNWL2kJ4RSGbq-tA" // replace with actual channel URL
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-violet hover:text-space bg-violet/10 hover:bg-violet/20 font-medium px-5 py-2 rounded-full transition-colors duration-300"
          >
            Visit Greg’s YouTube Channel →
          </a>
        </div>

        {/* Optional photo grid */}
        {/*
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {photos.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Singing ${i + 1}`}
              className="w-full h-auto rounded-2xl shadow-md object-cover border border-violet"
            />
          ))}
        </div>
        */}

        {/* Video grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {videos.map((video) => (
            <div key={video.id} className="flex flex-col items-center">
              <div className="w-full aspect-video overflow-hidden rounded-2xl shadow-md border border-violet">
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <h2 className="mt-4 text-xl font-semibold text-violet text-center">
                {video.title}
              </h2>
              <p className="text-sm text-space/80 text-center mt-2">
                {video.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Media;
